import React from 'react';
import $ from 'jquery';
import CreateExtraction from './CreateExtraction';
import FilterDropDown from './FilterDropDown';


class ExtractionSelector extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            createExtractionControl: null,
        };
        this.extractionChangeHandler = this.extractionChangeHandler.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.onExtractionCreated = this.onExtractionCreated.bind(this);
    }

    selectItem(extractionItem) {
        if (extractionItem) {
            this.filterDropDown.selectItem({
                id: extractionItem.id,
                label: extractionItem.name
            })
        } else {
            this.filterDropDown.selectItem(null);
        }
    }

    extractionChangeHandler(extractionElement) {
        // check if a valid extraction was selected
        var validExtractionSelected = (extractionElement != null) && (extractionElement.id != null);
        // if not valid, reset the extractionItem
        if (!validExtractionSelected) {
            this.props.onExtractionChange(null);
        }
        // check if the selected extraction changed, reverting to no selection is also a change
        var extractionChanged = (validExtractionSelected && extractionElement.id != this.props.currentExtractionId)
        // if the extraction did not change, do nothing
        if (!extractionChanged) {
            return;
        }
        // if the extraction changed to a valid extraction, update the extractionItem
        if (validExtractionSelected) {
            this.props.onExtractionChange(this.props.extractions?.find(e => e.id == extractionElement.id));
        }
    }

    onExtractionCreated(extractionItem) {
        this.props.onExtractionCreated(extractionItem);
    }

    render() {
        const { extractions, projectId } = this.props;
        return (
            <div style={{ display: projectId != null ? 'block' : 'none' }}>
                <FilterDropDown 
                    ref={instance => { this.filterDropDown = instance; }}
                    items={extractions}
                    placeholder="Please select an extraction, type to filter the list..." 
                    noMatchesMessage="No matching extractions" 
                    allowFreeText={false} 
                    allowNew={false} 
                    displayId={true}
                    isInvalid={false}
                    validationMessage="Please select an extraction"
                    onSelect={(extractionElement) => this.extractionChangeHandler(extractionElement)}
                    createNewLabel='Create a new Extraction'
                    createControl={this.createExtractionControl}
                />
                <CreateExtraction 
                    ref={instance => { this.createExtractionControl = instance; }} 
                    onExtractionCreated={(extractionItem) => this.onExtractionCreated(extractionItem)} 
                    extractionService={this.props.extractionService}
                    projectId={projectId}
                />
            </div>
        );
    }
}

export default ExtractionSelector;